"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return IntegrationStore;
    }
});
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _catchError = require("~/helpers/catchError");
const _utils = require("~/utils");
const _integrationstore = require("~/integrations/integration.store");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const prepareResponse = (obj, storeDefinition)=>{
    const keepKeys = [
        'id',
        'fk_integration_id',
        'type',
        'sub_type',
        'fk_workspace_id',
        'fk_user_id',
        'created_at',
        'updated_at',
        // slots occupied,
        ...Object.keys(storeDefinition)
    ];
    for (const [k, v] of Object.entries(storeDefinition)){
        if (k !== v.id) {
            obj[k] = obj[v.id];
            delete obj[v.id];
        }
    }
    return (0, _extractProps.extractProps)(obj, keepKeys);
};
let IntegrationStore = class IntegrationStore {
    static castType(data) {
        return data && new IntegrationStore(data);
    }
    static async insert(context, integration, fk_user_id, data, ncMeta = _Noco.default.ncMeta) {
        const storeDefinition = _integrationstore.STORE_DEFINITIONS[integration.type];
        if (!storeDefinition) {
            _catchError.NcError.badRequest('Invalid integration type');
        }
        const storeKeys = Object.keys(storeDefinition);
        const insertObj = (0, _extractProps.extractProps)(data, [
            ...storeKeys
        ]);
        if (_utils.isEE && !context.workspace_id) {
            _catchError.NcError.badRequest('Missing required fields');
        }
        insertObj.fk_workspace_id = context.workspace_id;
        insertObj.fk_user_id = fk_user_id;
        insertObj.fk_integration_id = integration.id;
        insertObj.type = integration.type;
        insertObj.sub_type = integration.sub_type;
        for (const [k, v] of Object.entries(storeDefinition)){
            if (v.required && !insertObj[k]) {
                _catchError.NcError.badRequest(`Missing required field: ${v.id}`);
            }
            if (insertObj[k] && v.type === _integrationstore.IntegrationSlotTypes.NUMBER && isNaN(Number(insertObj[k]))) {
                _catchError.NcError.badRequest(`Invalid type for field: ${v.id}`);
            }
            if (v.type === _integrationstore.IntegrationSlotTypes.BOOLEAN) {
                insertObj[k] = !!insertObj[k];
            }
            if (insertObj[k] && v.type === _integrationstore.IntegrationSlotTypes.ARRAY) {
                if (insertObj[k] && typeof insertObj[k] === 'string') {
                    try {
                        insertObj[k] = JSON.parse(insertObj[k]);
                    } catch (e) {
                        _catchError.NcError.badRequest(`Invalid type for field: ${v.id}`);
                    }
                }
                if (!Array.isArray(insertObj[k])) {
                    _catchError.NcError.badRequest(`Invalid type for field: ${v.id}`);
                }
                insertObj[k] = JSON.stringify(insertObj[k]);
            }
            if (insertObj[k] && v.type === _integrationstore.IntegrationSlotTypes.OBJECT) {
                if (insertObj[k] && typeof insertObj[k] === 'string') {
                    try {
                        insertObj[k] = JSON.parse(insertObj[k]);
                    } catch (e) {
                        _catchError.NcError.badRequest(`Invalid type for field: ${v.id}`);
                    }
                }
                if (typeof insertObj[k] !== 'object') {
                    _catchError.NcError.badRequest(`Invalid type for field: ${v.id}`);
                }
                insertObj[k] = JSON.stringify(insertObj[k]);
            }
            if (insertObj[k] && v.type === _integrationstore.IntegrationSlotTypes.STRING && typeof insertObj[k] !== 'string') {
                _catchError.NcError.badRequest(`Invalid type for field: ${v.id}`);
            }
            if (k !== v.id) {
                insertObj[v.id] = insertObj[k];
                delete insertObj[k];
            }
        }
        const { id } = await ncMeta.metaInsert2(insertObj.fk_workspace_id ? insertObj.fk_workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.INTEGRATIONS_STORE, insertObj);
        return await this.get({
            workspace_id: insertObj.fk_workspace_id
        }, id, ncMeta);
    }
    static async get(context, id, ncMeta = _Noco.default.ncMeta) {
        const integrationStoreData = await ncMeta.metaGet2(context.workspace_id ? context.workspace_id : _globals.RootScopes.WORKSPACE, context.workspace_id === _globals.RootScopes.BYPASS ? _globals.RootScopes.BYPASS : _globals.RootScopes.WORKSPACE, _globals.MetaTable.INTEGRATIONS_STORE, !context.workspace_id || context.workspace_id === _globals.RootScopes.BYPASS ? id : {
            id,
            fk_workspace_id: context.workspace_id
        }, null);
        const storeDefinition = _integrationstore.STORE_DEFINITIONS[integrationStoreData.type];
        if (!storeDefinition) {
            _catchError.NcError.badRequest('Invalid integration type');
        }
        const data = prepareResponse(integrationStoreData, storeDefinition);
        return this.castType(data);
    }
    static async list(context, integration, args, ncMeta = _Noco.default.ncMeta) {
        let integrationStoreData = await ncMeta.metaList2(context.workspace_id ? context.workspace_id : _globals.RootScopes.WORKSPACE, context.workspace_id === _globals.RootScopes.BYPASS ? _globals.RootScopes.BYPASS : _globals.RootScopes.WORKSPACE, _globals.MetaTable.INTEGRATIONS_STORE, _extends({
            condition: {
                fk_integration_id: integration.id
            }
        }, args.ignorePagination ? {} : {
            limit: (args.limit || 25) + 1,
            offset: args.offset || 0
        }));
        const pagination = args.ignorePagination ? {
            isLastPage: true,
            offset: 0
        } : {
            isLastPage: integrationStoreData.length <= (args.limit || 25),
            offset: args.offset || 0
        };
        if (!args.ignorePagination) {
            integrationStoreData = integrationStoreData.slice(0, args.limit || 25);
        }
        const list = integrationStoreData.map((d)=>{
            const storeDefinition = _integrationstore.STORE_DEFINITIONS[d.type];
            if (!storeDefinition) {
                _catchError.NcError.badRequest('Invalid integration type');
            }
            const data = prepareResponse(d, storeDefinition);
            return this.castType(data);
        });
        return {
            list,
            pagination
        };
    }
    static async sum(context, integration, fields, ncMeta = _Noco.default.ncMeta) {
        const storeDefinition = _integrationstore.STORE_DEFINITIONS[integration.type];
        if (!storeDefinition) {
            _catchError.NcError.badRequest('Invalid integration type');
        }
        for (const field of fields){
            if (!storeDefinition[field]) {
                _catchError.NcError.badRequest('Invalid field');
            }
            if (storeDefinition[field].type !== _integrationstore.IntegrationSlotTypes.NUMBER) {
                _catchError.NcError.badRequest('This operation is only supported for number fields');
            }
        }
        const qb = ncMeta.knexConnection(_globals.MetaTable.INTEGRATIONS_STORE);
        for (const field of fields){
            const storeField = storeDefinition[field];
            qb.sum(storeField.id, {
                as: field
            });
        }
        qb.where(_extends({
            fk_integration_id: integration.id
        }, context.workspace_id === _globals.RootScopes.BYPASS ? {} : {
            fk_workspace_id: context.workspace_id
        }));
        return await qb.first();
    }
    static async getLatest(context, integration, ncMeta = _Noco.default.ncMeta) {
        const storeDefinition = _integrationstore.STORE_DEFINITIONS[integration.type];
        if (!storeDefinition) {
            _catchError.NcError.badRequest('Invalid integration type');
        }
        const result = await ncMeta.knexConnection(_globals.MetaTable.INTEGRATIONS_STORE).select('*').where(_extends({
            fk_integration_id: integration.id
        }, context.workspace_id === _globals.RootScopes.BYPASS ? {} : {
            fk_workspace_id: context.workspace_id
        })).orderBy('created_at', 'desc').first();
        if (!result) {
            return null;
        }
        const data = prepareResponse(result, storeDefinition);
        return this.castType(data);
    }
    constructor(data){
        Object.assign(this, data);
    }
};
